<template>
  <div v-if="isVisible" class="alert site-alert" role="alert">
    <div class="site-alert__content">
      <div class="alert-header d-flex align-items-center">
        <p class="alert-header-text" v-html="info?.headerText"></p>
      </div>

      <div
        class="alert-text"
        v-if="info?.informationText"
        v-html="info.informationText"
      ></div>
    </div>
  </div>
</template>

<script lang="ts">
//import UseSvg from "./UseSvg.vue";
import { AlertBannerInfo, useAlertStore } from "@/stores/alert";
import { PropType, ref, toRefs } from "vue";

export default {
  name: "AlertBanner",
  components: {
   // UseSvg,
  },
  props: { info: Object as PropType<AlertBannerInfo> },
  setup(props) {
    const isVisible = ref(true);

    const closeAlertBanner = () => {
      isVisible.value = false;
    };

    const { info } = toRefs(props);

    return {
      isVisible,
      closeAlertBanner,
      info
    };
  }
};
</script>

<style lang="scss" scoped>
.alert {
  margin: 24px 0;
  border: 1px solid var(--spsm-orange-1);
  background-color: var(--spsm-orange-5);
  padding: 16px;
}

.alert-header-text{
  font-weight: 400;
  font-size: 22px;
  font-family: SPSM-Serif;
}

.site-alert__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start; // ← viktigt (vänsterställ)
}

.alert-header {
  display: flex;
  text-align: left;
  font-weight: 700;
  color: var(--spsm-red-1);
  margin-bottom: 4px;


}

.alert-text {
  color: #000;
  text-align: left; // ← säkerställ vänster
}
</style>
